import { NAV_PATHS } from '@modules/common/constants';
import { CreateNewUnifiedFieldButton } from '@modules/ManageUnifiedFields/components/CreateNewUnifiedFieldButton';
import { ManageUnifiedFieldsSearchInput } from '@modules/ManageUnifiedFields/components/ManageUnifiedFieldsSearchInput';
import { UnifiedFieldsDataGrid } from '@modules/ManageUnifiedFields/components/UnifiedFieldsDataGrid';
import { ChevronRightRounded } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const ManageUnifiedFieldsContainer = () => {
  const [searchValue, setSearchValue] = useState<string>('');
  const navigate = useNavigate();

  const manageUnifieldIntegrationHeader = (
    <Stack justifyContent="space-between" direction="row">
      <Stack direction="row" alignItems="center">
        <Typography
          variant="h5"
          color="text.secondary"
          sx={{
            '&:hover': {
              color: 'text.primary',
              cursor: 'pointer',
            },
          }}
          onClick={() => navigate(`/${NAV_PATHS.SETTINGS_INTEGRATIONS}`)}
        >
          Integrations
        </Typography>
        <ChevronRightRounded />
        <Typography variant="h5">Manage Unified Fields</Typography>
      </Stack>
      <Stack spacing={2} direction="row">
        <CreateNewUnifiedFieldButton />
      </Stack>
    </Stack>
  );

  return (
    <Stack p={3}>
      {manageUnifieldIntegrationHeader}
      <Box my={5}>
        <ManageUnifiedFieldsSearchInput
          searchValue={searchValue}
          setSearchValue={setSearchValue}
        />
      </Box>
      <UnifiedFieldsDataGrid searchValue={searchValue} />
    </Stack>
  );
};
